import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#bff0fd";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontSize: 12,
    fontStyle: "bold"
  },
  description: {
    width: "90%",
    textAlign: "right",
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    paddingRight: 30,
    paddingTop: 4,
  },
  total: {
    width: "10%",
    textAlign: "center",
    paddingRight: 6,
    paddingTop: 4,
    borderRightColor: borderColor,
    borderRightWidth: 1,
  }
});

const ClientReportsTableFooter = ({ itemsTotal }) => {

  return (
    <React.Fragment>
      <View style={styles.row}>
        <Text style={styles.description}>Grand Total</Text>
        <Text style={styles.total}>{itemsTotal}</Text>
      </View>
    </React.Fragment>
  );
};

export default ClientReportsTableFooter;
